import React from 'react';

const styles = {
  container: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '32px 16px',
    color: '#916859'
  },
  sectionContainer: {
    marginBottom: '88px'
  },
  sectionTitle: {
    fontSize: '2rem',
    fontWeight: '500',
    marginBottom: '8px',
    fontFamily: "'EditorsNote', serif",
  },
  sectionDescription: {
    fontSize: '1rem',
    marginBottom: '24px',
    color: '#916859',
    opacity: 0.9,
    maxWidth: '800px',
    lineHeight: '1.5'
  },
  grid: {
    display: 'grid',
    gap: '16px'
  },
  gridItem: {
    position: 'relative',
    overflow: 'hidden',
    aspectRatio: '1/1', // Changing to square to make them more compact
  },
  image: {
    position: 'absolute',
    inset: '0',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'transform 0.3s ease',
    width: '100%',
    height: '100%'
  }
};

// Media query helper function for responsive design
const getResponsiveStyle = () => {
  const mediaStyles = document.createElement('style');
  mediaStyles.type = 'text/css';
  mediaStyles.innerHTML = `
    /* Small screens - 1 column */
    @media (max-width: 599px) {
      .gallery-grid {
        grid-template-columns: 1fr;
      }
    }
    
    /* Medium screens - 2 columns */
    @media (min-width: 600px) and (max-width: 899px) {
      .gallery-grid {
        grid-template-columns: repeat(2, 1fr);
      }

      sectionContainer: {
        marginBottom: '48px',
        fontSize: '32px',
      },
    }
    
    /* Large screens - 3 columns */
    @media (min-width: 900px) and (max-width: 1199px) {
      .gallery-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }
    
    /* Extra large screens - 4 columns */
    @media (min-width: 1200px) {
      .gallery-grid {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  `;
  document.head.appendChild(mediaStyles);
};

const GalleryGrid = ({ galleryArray = [], loading = false }) => {
  // Add responsive styles when component mounts
  React.useEffect(() => {
    getResponsiveStyle();

    // Mouse hover effect
    const handleMouseEnter = (e) => {
      e.currentTarget.style.transform = 'scale(1.1)';
    };

    const handleMouseLeave = (e) => {
      e.currentTarget.style.transform = 'scale(1)';
    };

    const images = document.querySelectorAll('.gallery-image');
    images.forEach(img => {
      img.addEventListener('mouseenter', handleMouseEnter);
      img.addEventListener('mouseleave', handleMouseLeave);
    });

    // Cleanup event listeners
    return () => {
      images.forEach(img => {
        img.removeEventListener('mouseenter', handleMouseEnter);
        img.removeEventListener('mouseleave', handleMouseLeave);
      });

      // Also remove the style element when component unmounts
      const styleElement = document.querySelector('style');
      if (styleElement) {
        styleElement.parentNode.removeChild(styleElement);
      }
    };
  }, []);

  if (loading) {
    return (
      <div style={styles.container}>
        <style>{`
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 0.3; }
            100% { opacity: 0.6; }
          }
        `}</style>
        {[1, 2].map((sectionIndex) => (
          <div key={sectionIndex} style={styles.sectionContainer}>
            <div style={{height: '32px', width: '30%', backgroundColor: '#333', marginBottom: '16px', borderRadius: '4px', animation: 'pulse 1.5s infinite'}} />
            <div className="gallery-grid" style={styles.grid}>
              {[1, 2, 3, 4, 5, 6].map((imgIndex) => (
                <div key={imgIndex} style={styles.gridItem}>
                  <div style={{width: '100%', height: '100%', backgroundColor: '#222', animation: 'pulse 1.5s infinite'}} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {galleryArray.map((section, sectionIndex) => (
        <div key={sectionIndex} style={styles.sectionContainer}>
          <h2 style={styles.sectionTitle}>{section.title}</h2>
          {section.description && <p style={styles.sectionDescription}>{section.description}</p>}
          <div
            className="gallery-grid"
            style={styles.grid}
          >
            {section.images.map((image, imageIndex) => (
              <div
                key={`${sectionIndex}-${imageIndex}`}
                style={styles.gridItem}
              >
                <div
                  className="gallery-image"
                  style={{
                    ...styles.image,
                    backgroundImage: `url(${image})`,
                  }}
                  role="img"
                  aria-label={`Image ${imageIndex + 1} from ${section.title}`}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;

// const GalleryGrid = ({ galleryArray }) => {
//   // Function to chunk the array into groups of 5
//   const chunkArray = (arr, size) => {
//     return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
//       arr.slice(i * size, i * size + size)
//     );
//   };

//   const chunkedGallery = chunkArray(galleryArray, 5);

//   return (
//     <div className="gallery-container">
//       {chunkedGallery.map((chunk, chunkIndex) => (
//         <section key={chunkIndex} className="gallery__container__main2">
//           {chunk.map((gallery, index) => (
//             <div
//               key={`${chunkIndex}-${index}`}
//               className={`gallery-item ${index === 1 ? 'span-two' : ''}`}
//               style={{
//                 backgroundImage: `url(${gallery.image})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 backgroundRepeat: 'no-repeat',
//               }}
//               aria-label='Dudu world photos showcasing them in different events.'
//             ></div>
//           ))}
//         </section>
//       ))}
//       <style jsx>{`
//         .gallery-container {
//           margin-top: 150px;
//           max-width: 1680px;
//           margin-left: auto;
//           margin-right: auto;
//         }
//         .gallery__container__main2 {
//           display: grid;
//           grid-template-columns: repeat(3, minmax(0, 1fr));
//           grid-template-rows: repeat(2, minmax(350px, auto));
//           gap: 20px;
//           margin-bottom: 40px;
//         }
//         .gallery__container__main2:last-child {
//            display: none;
//         }
//         .gallery-item {
//           max-width: 560px;
//           width: 100%;
//           height: 100%;
//           min-height: 350px;
//         }
//         .span-two {
//           grid-row: span 2;
//         }
//         @media (max-width: 1200px) {
//           .gallery__container__main2 {
//             grid-template-columns: repeat(2, minmax(0, 1fr));
//             grid-template-rows: repeat(3, minmax(350px, auto));
//           }
//           .span-two {
//             grid-column: 1;
//           }
//         }
//         @media (max-width: 768px) {
//          .gallery-container {
//           margin-top: 40px;
//         }
//           .gallery__container__main2 {
//           margin-bottom: 0;
//             grid-template-columns: 1fr;
//             grid-template-rows: repeat(4, minmax(350px, auto));
//           }
//           .span-two {
//             grid-row: auto;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };